export const userColumns = [

    {
        field: "insuranceName",
        headerName: "Insurance Name",
        width: 200,
    },
    {
        field: "insuranceType",
        headerName: "Insurance Type",
        width: 150,
    },
    {
        field: "activeStatus",
        headerName: "Active Status",
        width: 150,
    },
    {
        field: "remarks",
        headerName: "remarks",
        width: 150,
    },

];